export default [
    {
        path: "/dealer",
        name: "producer",
        redirect: "/dealer/dashboard",
        component: () => import("@/components/admin/layout/ProviderDashboard.vue"),
        children: [
            {
                path: '/dealer/dashboard',
                name: 'producer-dashboard',
                component: () => import('@/components/provider/pages/Dashboard.vue'),
                meta: {
                    title: 'Dashboard',
                }
            },
            {
                path: '/dealer/support',
                name: 'producer-support',
                component: () => import('@/components/provider/pages/profile/Support.vue'),
                meta: {
                    title: 'Support',
                }
            },
            {
                path: '/dealer/support-response/:supportId',
                name: 'support-response',
                component: () => import('@/components/provider/pages/support-response/SupportResponse.vue'),
                meta: {
                    title: 'Support Response',
                }
            },
            // {
            //     path: '/dealer/cancellation-settings',
            //     name: 'cancellation-settings',
            //     component: () => import('@/components/provider/pages/product-settings/CancellationSettings.vue'),
            //     meta: {
            //         title: 'Add Room Cancellation Fees',
            //     }
            // },
            {
                path: '/dealer/general-setting',
                name: 'general-setting',
                component: () => import('@/components/provider/pages/product-settings/GeneralSetting.vue'),
                meta: {
                    title: 'General Setting',
                }
            },
            // {
            //     path: '/dealer/properties',
            //     name: 'properties',
            //     component: () => import('@/components/provider/pages/property/Properties.vue'),
            //     meta: {
            //         title: 'List Properties',
            //     }
            // },
            // {
            //     path: '/dealer/add-property',
            //     name: 'add-property',
            //     component: () => import('@/components/provider/pages/property/AddProperty.vue'),
            //     meta: {
            //         title: 'Add Property',
            //     }
            // },
            // {
            //     path: '/dealer/edit-property/:id',
            //     name: 'edit-property',
            //     component: () => import('@/components/provider/pages/property/EditProperty.vue'),
            //     meta: {
            //         title: 'Edit Property',
            //     }
            // },
            {
                path: '/dealer/edit-profile/:id',
                name: 'edit-profile',
                component: () => import('@/components/provider/pages/profile/EditProfile.vue'),
                meta: {
                    title: 'Edit Profile',
                }
            },
            {
                path: '/dealer/change-password/:id',
                name: 'change-profile',
                component: () => import('@/components/provider/pages/profile/ChangePassword.vue'),
                meta: {
                    title: 'Edit Profile',
                }
            },
            {
                path: '/dealer/inbox',
                name: 'provider-inbox',
                component: () => import('@/components/provider/pages/inbox/Inbox.vue'),
                meta: {
                    title: 'Inbox',
                }
            },
            {
                path: '/dealer/inbox/:id',
                name: 'producer-inbox-details',
                component: () => import('@/components/provider/pages/inbox/InboxDetails.vue'),
                meta: {
                    title: 'Inbox Details',
                }
            },
            {
                path: '/dealer/orders',
                name: 'provider-orders',
                component: () => import('@/components/provider/pages/orders/Orders.vue'),
                meta: {
                    title: 'Orders',
                }
            },
            {
                path: '/dealer/invoices',
                name: 'provider-invoices',
                component: () => import('@/components/provider/pages/invoice/Invoice.vue'),
                meta: {
                    title: 'Invoices',
                }
            },
            {
                path: '/dealer/order/:id',
                name: 'order-details',
                component: () => import('@/components/provider/pages/orders/OrderDetails.vue'),
                meta: {
                    title: 'Order Details',
                }
            },
            // {
            //     path: '/dealer/bookings',
            //     name: 'bookings',
            //     component: () => import('@/components/provider/pages/bookings/Bookings.vue'),
            //     meta: {
            //         title: 'List Bookings',
            //     }
            // },
            // {
            //     path: '/dealer/booking/:id',
            //     name: 'bookings',
            //     component: () => import('@/components/provider/pages/bookings/BookingDetails.vue'),
            //     meta: {
            //         title: 'Booking Details',
            //     }
            // },
            // PRODUCT
            {
                path: '/dealer/products',
                name: 'producer-products',
                component: () => import('@/components/provider/pages/product/Products.vue'),
                meta: {
                    title: 'List Products',
                }
            },
            {
                path: '/dealer/add-product',
                name: 'producer-add-product',
                component: () => import('@/components/provider/pages/product/AddProduct.vue'),
                meta: {
                    title: 'Add Product',
                }
            },
            {
                path: '/dealer/edit-product/:id',
                name: 'producer-edit-product',
                component: () => import('@/components/provider/pages/product/EditProduct.vue'),
                meta: {
                    title: 'Edit Product',
                }
            },
            {
                path: '/dealer/documentation',
                name: 'documentation',
                component: () => import('@/components/provider/pages/documents/Documents.vue'),
                meta: {
                    title: 'Documentation',
                }
            },
        ]
    },
]
